import React, { useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import { connect } from 'react-redux';
import './style.scss';
import { Select, Spin } from 'antd';
import { GetDocSequence } from '../../../../modules/documentSequence';


const DocumentNumberSeqInput = ({ getDocSequence, entityName, tenantId, onChangeFromProps, callback,
  docTitle, formSubmitted, valueFromProps, documentSequenceLoading, docSeqId, setInitialDocSeqNumber,
  updateCase, rowClassName, inputRowClassName, inputWrapperClassName, prefixRequiredOnly, documentSequence, preventApiCall,
  labelClassName, containerClassName, inputClassName, selectorStyle, seqClassName }) => {
  const [currentDocSeqValue, setCurrentDocSeqValue] = useState(null);
  const [sequenceData, setSequenceData] = useState(null);

  useEffect(() => {
    if (tenantId && entityName && !updateCase) {
      if (!preventApiCall) {
        getDocSequence({
          query: {
            tenant_id: tenantId,
            entity_name: entityName || '',
          },
        }, (data) => {
          const defaultSeq = data?.document_sequences?.find(item => item.is_default);
          const seq = `${defaultSeq.seq_prefix || ''}${defaultSeq.seq_counter + 1 || ''}` || null;
          const prefix = `${defaultSeq.seq_prefix || ''}`;
          onChangeFromProps(undefined, (prefixRequiredOnly ? prefix : seq), defaultSeq?.seq_id);
          setInitialDocSeqNumber(seq);
          setSequenceData(data);
        });
      } else {
        setSequenceData(documentSequence);
      }
    }
  }, [tenantId, entityName, callback]);

  const handleSelectChange = (value) => {
    const selectedSeq = sequenceData?.document_sequences?.find(item => item.seq_id === value);
    if (selectedSeq) {
      const newDocSeqValue = `${selectedSeq.seq_prefix || ''}${selectedSeq.seq_counter + 1 || ''}`;
      const prefix = `${selectedSeq.seq_prefix || ''}`;
      onChangeFromProps(undefined, (prefixRequiredOnly ? prefix : newDocSeqValue), selectedSeq.seq_id);
      setInitialDocSeqNumber(newDocSeqValue);
      setCurrentDocSeqValue(null);
    }
  };
  return (
    <>
      <div className={rowClassName ?? "ant-col-md-6"}>
        <div className={inputRowClassName ?? "form__input-row"}>
          <div className={labelClassName ?? "form__input-row__label"} >
            <H3Text
              text={docTitle || 'Document Number Sequence'}
              className={labelClassName || ''}
              required />
          </div>
          <div className={inputWrapperClassName ?? ''}>
            <H3FormInput
              name={`${docTitle.toProperCase()}`}
              type="text"
              containerClassName={`${containerClassName ?? "orgInputContainer form__input-row__input"} ${(formSubmitted && !valueFromProps) ? 'form__input-row__input-error' : ''}`}
              labelClassName="orgFormLabel"
              inputClassName={inputClassName ?? "orgFormInput input"}
              placeholder=""
              onChange={(e) => {
                onChangeFromProps(e, undefined, docSeqId);
                setCurrentDocSeqValue(null)
              }}
              value={valueFromProps}
              disabled={documentSequenceLoading || prefixRequiredOnly}
            />
          </div>
          {!updateCase && (<>
            <Select
              onChange={handleSelectChange}
              value={currentDocSeqValue}
              size="small"
              bordered={false}
              className='doc-number-seq-select'
              options={sequenceData?.document_sequences?.map((item) => ({
                label: `${item.seq_prefix}${item.seq_counter + 1}`,
                value: item.seq_id || '-',
              })) || []}
              loading={documentSequenceLoading}
              style={selectorStyle || {
                opacity: 0,
                backgroundColor: 'transparent',
                zIndex: 1,
                top: '-3px',
                width: '35%',
              }}
            >
            </Select>

            <div className={seqClassName || 'doc-number-seq-select'} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              Change Sequence
              {(documentSequenceLoading || !sequenceData?.document_sequences?.length) && (
                <Spin size="small" />
              )}
            </div>
          </>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({
  GetDocSequence,
}) => ({
  documentSequence: GetDocSequence.data,
  documentSequenceLoading: GetDocSequence.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getDocSequence: (payload, callback) => dispatch(GetDocSequence.actions.request(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentNumberSeqInput));
